import axios from 'axios'
const config_file = {
    headers: {
        'content-type': 'multipart/form-data'
    }
}

export default function useApi() {
    async function getReports(fruit_id, days) {
        const response = await axios.get('/fruit/report/' + fruit_id + '/' + days);
        return response.data;
    }

    async function orderFruitsBy(term, order) {
        const response = await axios.get('/fruit/orderBy/' + term + '/' + order);
        return response.data;
    }

    async function orderCategoryFruitsBy(cat, term, order) {
        const response = await axios.get('/fruit/orderCategoryBy/' + cat + '/' + term + '/' + order);
        return response.data;
    }

    async function syncFruitPrices() {
        const response = await axios.post('/admin/products-from-drive');
        return response.data;
    }

    async function addReport(report) {
        const response = await axios.post('/resource/report/create', report);
        return response;
    }

    async function editReport(report) {
        const response = await axios.put('/resource/report/edit', report);
        return response;
    }

    async function deleteReport(report) {
        const response = await axios.delete('/resource/report/delete/' + report.id);
        return response;
    }

    async function addFruit(fruit, image) {
        const response = await axios.post('/resource/fruit/create', fruit);
        const response_image = await axios.post('/resource/fruit/image/upload/' + response.data.fruit.id, image, config_file);
        console.log(response_image);
        return response;
    }

    async function updateFruit(fruit, image) {
        const response = await axios.put('/resource/fruit/edit', fruit);
        console.log(image)
        if (image != null) {
            const response_image = await axios.post('/resource/fruit/image/upload/' + response.data.fruit.id, image, config_file);
        }
        return response;
    }

    async function deleteFruit(fruit) {
        const response = await axios.delete('/resource/fruit/delete/' + fruit.id);
        return response;
    }

    async function addCategory(category) {
        const response = await axios.post('/resource/category/create', category);
        return response;
    }

    async function deleteCategory(category) {
        const response = await axios.delete('/resource/category/delete/' + category.id);
        return response;
    }

    async function addFruitToCategory(values) {
        const response = await axios.post('/resource/fruit/category/attach', values);
        return response;
    }

    async function removeFruitToCategory(values) {
        const response = await axios.post('/resource/fruit/category/detach', values);
        return response;
    }

    async function addUser(user) {
        const response = await axios.post('/resource/user/create', user);
        return response;
    }

    async function updateUser(user) {
        const response = await axios.put('/resource/user/edit', user);
        return response;
    }

    async function deleteUser(user) {
        const response = await axios.delete('/resource/user/delete/' + user.id);
        return response;
    }

    async function getClassifications() {
        const response = await axios.get('/resource/classifications');
        return response.data;
    }

    async function addClassification(classification) {
        const response = await axios.post('/resource/classification/create', classification);
        return response;
    }

    async function updateClassification(classification) {
        const response = await axios.put('/resource/classification/edit', classification);
        return response;
    }

    async function deleteClassification(classification) {
        const response = await axios.delete('/resource/classification/delete/' + classification.id);
        return response;
    }

    async function addFruitToClassification(values) {
        const response = await axios.post('/resource/fruit/classification/attach', values);
        return response;
    }

    async function removeFruitToClassification(values) {
        const response = await axios.post('/resource/fruit/classification/detach', values);
        return response;
    }

    async function uploadClassificationExcel(file) {
        const response = await axios.post('/resource/classifications/file/upload', file, config_file);
        return response;
    }

    async function addBlog(blog, image) {
        const response = await axios.post('/resource/blog/create', blog);
        const response_image = await axios.post('/resource/blog/image/upload/' + response.data.blog.id, image, config_file);
        console.log(response_image);
        return response;
    }

    async function updateBlog(blog, image) {
        const response = await axios.put('/resource/blog/edit', blog);
        if (image != null) {
            const response_image = await axios.post('/resource/blog/image/upload/' + response.data.blog.id, image, config_file);
        }
        return response;
    }

    async function deleteBlog(blog) {
        const response = await axios.delete('/resource/blog/delete/' + blog.id);
        return response;
    }

    async function updateConfig(blog) {
        const response = await axios.put('/resource/config/edit', blog);

        return response;
    }

    async function addFruitToFavorites(values) {
        const response = await axios.post('/resource/fruit/favorites/add', values);
        return response;
    }

    async function removeFruitToFavorites(values) {
        const response = await axios.post('/resource/fruit/favorites/remove', values);
        return response;
    }

    async function addFarm(farm) {
        const response = await axios.post('/resource/farm/create', farm);
        return response;
    }

    async function deleteFarm(farm) {
        const response = await axios.delete('/resource/farm/delete/' + farm.id);
        return response;
    }

    async function addHarvest(farmId, harvest) {
        const response = await axios.post('/resource/harvest/create/' + farmId, harvest);
        return response;
    }

    async function deleteHarvest(harvest) {
        const response = await axios.delete('/resource/harvest/delete/' + harvest.id);
        return response;
    }

    async function saveHarvestOffer(harvestId, offer) {
        const response = await axios.put('/resource/harvest/' + harvestId + '/offer', offer);
        return response;
    }

    async function changeHarvestOfferStatus(harvestId, action) {
        const response = await axios.patch('/resource/harvest/' + harvestId + '/offer/status', { action });
        return response;
    }

    async function addTree(harvestId, tree) {
        const response = await axios.post('/resource/tree/create/' + harvestId, tree);
        return response;
    }

    async function updateTree(treeId, tree) {
        const response = await axios.put('/resource/tree/edit/' + treeId, tree);
        return response;
    }

    async function deleteTree(treeId) {
        const response = await axios.delete('/resource/tree/delete/' + treeId);
        return response;
    }

    async function saveClassificationsImages(image) {
        const response_image = await axios.post('/resource/classifications/image/upload', image, config_file);
        return response_image;
    }

    return {
        getReports,
        addReport,
        editReport,
        deleteReport,
        addFruit,
        updateFruit,
        deleteFruit,
        addCategory,
        deleteCategory,
        addFruitToCategory,
        removeFruitToCategory,
        addUser,
        updateUser,
        deleteUser,
        getClassifications,
        addClassification,
        updateClassification,
        deleteClassification,
        addFruitToClassification,
        removeFruitToClassification,
        uploadClassificationExcel,
        orderFruitsBy,
        orderCategoryFruitsBy,
        syncFruitPrices,
        addBlog,
        updateBlog,
        deleteBlog,
        updateConfig,
        addFruitToFavorites,
        removeFruitToFavorites,
        addFarm,
        deleteFarm,
        addHarvest,
        deleteHarvest,
        saveHarvestOffer,
        changeHarvestOfferStatus,
        addTree,
        updateTree,
        deleteTree,
        saveClassificationsImages
    }
}
